import React from "react";
import { Route } from "lucide-react";
import { useGetCallFlowStepsQuery, useGetHomeQuery } from "@/store/rest_api";
import { MembershipRole } from "@/enum/MembershipRole";
import { MembershipStatus } from "@/enum/MembershipStatus";
import { NODE_LABELS } from "@/util/callFlowNodes";

const ENTRY_STEP_LABELS: Record<string, string> = {
  SCREENING: "Caller screening",
  DIALER_RETURN_CALL: "Rang the agent from the dialer call",
};

export function CallFlowStepsList({ callId }: { callId: string }) {
  const { data: user } = useGetHomeQuery();
  const membership = user?.activeMembership;
  const canView =
    membership?.status === MembershipStatus.ACTIVE &&
    (membership.role === MembershipRole.OWNER || membership.role === MembershipRole.ADMIN);
  const { data: steps } = useGetCallFlowStepsQuery(callId, { skip: !canView });

  if (!canView || !steps?.length) {
    return null;
  }

  return (
    <div className="space-y-1">
      <div className="text-xs font-medium text-muted-foreground uppercase tracking-wider">Flow steps</div>
      {steps.map((step) => (
        <div key={step.id} className="flex items-center gap-1.5 text-xs text-muted-foreground">
          <Route className="h-3 w-3" />
          <span className="text-foreground">
            {step.actionType
              ? (ENTRY_STEP_LABELS[step.actionType] ?? NODE_LABELS[step.actionType] ?? step.actionType)
              : "Step"}
          </span>
          <span>· {step.result ? step.result.toLowerCase().replaceAll("_", " ") : "in progress"}</span>
          <span>· {new Date(step.enteredAt).toLocaleTimeString()}</span>
        </div>
      ))}
    </div>
  );
}
